<template>
  <ul class="tw:hidden tw:md:grid tw:md:grid-cols-2 tw:md:grid-rows-2 tw:md:gap-4 tw:lg:grid-cols-1 tw:lg:grid-rows-4">
    <li v-for="card in cards" :key="card.id">
      <button class="tw:h-full tw:cursor-pointer" @click="emit('onCardClicked', { id: card.id })">
        <RateConnectBenefitsCard
          :item="card"
          class="tw:h-full"
          :class="{ 'tw:lg:translate-x-[4px]': card.id === currentCardId }"
          :iconSvgProps="card.id === currentCardId ? { circleInnerColor: '#FFE7A1', class: 'tw:lg:scale-140' } : null"
        />
      </button>
    </li>
  </ul>
</template>

<script setup>
import RateConnectBenefitsCard from '@/components/productPage/rateConnect/benefits/RateConnectBenefitsCard.vue'

const emit = defineEmits(['onCardClicked'])

defineProps({
  cards: {
    type: Array,
    required: true,
  },
  currentCardId: {
    type: String,
    required: false,
  },
})
</script>
